module.exports = __webpack_public_path__ + "assets/img/btn-detail-327da198.png";